import { createFileRoute } from '@tanstack/react-router'

import { HousekeepingPage } from '@/components/Internal/System/HousekeepingPage'

export const Route = createFileRoute(
  '/internal/system/operations/housekeeping',
)({
  component: HousekeepingPage,
})
